module.exports = __webpack_public_path__ + "img/logo.349ec2b3.png";